import React, { useState } from 'react';
import { useField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { InlineTextButton, SecondaryButton } from '../Button/Button';
import IconEdit from '../IconEdit/IconEdit';
import InpostGeowidget from '../InpostGeowidget/InpostGeowidget';
import { H3 } from '../Heading/Heading';
import Modal from '../Modal/Modal';
import ValidationError from '../ValidationError/ValidationError';

import css from './FieldInpostGeowidget.module.css';

const FieldInpostGeowidget = ({
  id,
  name,
  token,
  language,
  config,
  label,
  className,
  onManageDisableScrolling,
  ...fieldConfig
}) => {
  const { input, meta } = useField(name, fieldConfig);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { value, onChange, onFocus, onBlur } = input;
  const { invalid, touched, error } = meta;

  const hasError = touched && invalid && error;

  const openModal = () => {
    setIsModalOpen(true);
    onFocus();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    onBlur();
  };

  const onPointSelect = ({ name, address }) => {
    onChange({ name, address });
    closeModal();
  };

  return (
    <div className={classNames(className, hasError && css.error)}>
      {value ? (
        <div className={css.displayContainer}>
          <H3 className={css.displayHeading}>{label}</H3>
          <InlineTextButton type="button" className={css.editButton} onClick={openModal}>
            <IconEdit />
          </InlineTextButton>
          <ul className={css.displayValues}>
            <li>{value.name}</li>
            {value.address && (
              <li>
                {value.address.line1} {value.address.line2}
              </li>
            )}
          </ul>
        </div>
      ) : (
        <SecondaryButton type="button" onClick={openModal}>
          <FormattedMessage id="FieldInpostGeowidget.heading" values={{ label }} />
        </SecondaryButton>
      )}
      <ValidationError fieldMeta={meta} />
      <Modal
        id={id}
        isOpen={isModalOpen}
        onManageDisableScrolling={onManageDisableScrolling}
        onClose={closeModal}
        className={css.modal}
        contentClassName={css.modalContent}
        containerClassName={css.modalContainer}
        closeButtonClassName={css.modalCloseButton}
        scrollLayerClassName={css.modalScrollLayer}
        isClosedClassName={css.modalIsClosed}
        isOpenClassName={css.modalIsOpen}
        usePortal
        withoutLabel
      >
        <H3 className={css.modalHeading}>
          <FormattedMessage id="FieldInpostGeowidget.heading" values={{ label }} />
        </H3>
        {isModalOpen && (
          <div className={css.geowidget}>
            <InpostGeowidget
              id={`${id || 'FieldInpostGeowidget'}_geowidget`}
              token={token}
              language={language}
              config={config}
              onPointSelect={onPointSelect}
            />
          </div>
        )}
      </Modal>
    </div>
  );
};

export default FieldInpostGeowidget;
